var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showOverlay)?_c(_setup.StartPageJwtvOverlay):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }